import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Button from './Button'

import classes from './ItemFooter.module.scss'

const ItemFooter = ({ onPrevious, hint, nextLabel, onNext = () => {}, nextDisabled = false, loading = false, className }) => {
  const { t } = useTranslation()

  return (
    <div className={classNames('d-flex align-items-center justify-content-between flex-wrap', classes.footer, className)}>
      <Button variant='outline' className={classes.footerButton} onClick={onPrevious}>{t('portal.certification.item.previous')}</Button>
      <div className={classNames('d-flex align-items-center flex-wrap', classes.actions)}>
        {hint && <span className={classes.hint}>{hint}</span>}
        {nextLabel && <Button className={classes.footerButton} onClick={onNext} disabled={nextDisabled} loading={loading}>{nextLabel}</Button>}
      </div>
    </div>
  )
}

ItemFooter.propTypes = {
  onPrevious: PropTypes.func.isRequired,
  hint: PropTypes.string,
  nextLabel: PropTypes.string,
  onNext: PropTypes.func,
  nextDisabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
}

export default ItemFooter
